<template>
    <div class="page" :class="pc?'pc':''">
        <div
            class="toasts show"
            :style="{ background: bg_color, color: color }"
            v-html="msg"
            @click="Ihide"
        ></div>
    </div>
</template>

<script>
export default {
    props: {
        msg: {
            type: String,
            default: "提交成功",
        },
        intval: {
            type: Number,
            default: 1500,
        },
        bg_color: {
            type: String,
            default: "rgba(0,0,0,.85)",
        },
        color: {
            type: String,
            default: "#fff",
        },
        link: {
            type: String,
            default: "",
        },
    },
    name: "Toast",
    data() {
        return {
			pc:false
		};
    },
    created() {
		if(!isMobile()){
			this.pc = true
		}
		else{
			this.pc = false
		}
	},
    mounted() {
        this.close();
    },
    methods: {
        close() {
            let that = this;
            setTimeout(() => {
                that.hide();
                if (that.link != "") {
                    that.$router.replace(that.link);
                }
            }, that.intval);
        },
        isMobile() {
            let flag = navigator.userAgent.match(
                // match方法可在字符串内检索指定的值，
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            return flag;
        },
        Ihide() {
            this.$emit("toastHide", false);
            if (this.link != "") {
                this.$router.replace(this.link);
            }
        },
        hide() {
            this.$emit("toastHide", false);
            if (this.link != "") {
                this.$router.replace(this.link);
            }
        },
    },
};
</script>
<style scoped>
.page {
    width: 100%;
    height: 100%;
    position: fixed;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    z-index: 10000;
}
.toasts {
    display: inline-block;
    width: auto;
    max-width: 650px;
    border-radius: 5px;
    font-size: 28px;
    letter-spacing: 2px;
    color: #fff;
    line-height: 1.35;
    padding: 15px 50px;
    word-break: break-all;
    text-align: center;
    transform: translateY(50px);
    opacity: 0;
    transition: all 1.2s ease-out;
}
.show {
    animation: tofxi 0.5s ease-in-out forwards;
}
.pc{
	transform: scale(.65);
}
@keyframes tofxi {
    from {
        transform: translateY(50px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/toast.vue